import { render, staticRenderFns } from "./COM_Header_Setting.vue?vue&type=template&id=42054468&"
import script from "./COM_Header_Setting.vue?vue&type=script&lang=js&"
export * from "./COM_Header_Setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports